module.exports = __webpack_public_path__ + "img/sleeping_face.203a37c3.gif";